// ─── Template Preview Page ────────────────────────────────────
// Test route to render new section-based templates.
// /preview/template/:templateId

import React from 'react';
import { useParams } from 'react-router-dom';
import TemplateRenderer from '../components/renderer/TemplateRenderer';
import { elegantWeddingV1 } from '../lib/templates/elegant-wedding-v1';
import { noirVinylV1 } from '../lib/templates/noir-vinyl-v1';

const TEMPLATES = {
  'elegant-wedding-v1': elegantWeddingV1,
  'noir-vinyl-v1': noirVinylV1,
};

// Sample data for preview
const SAMPLE_DATA = {
  'hero-1': {
    introLabel: "We're getting married",
    title: 'Sofia & Miguel',
    subtitle: 'Grand Ballroom, Sintra',
    dateText: '12 September 2026',
    backgroundImage: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=1200',
    ctaText: 'Open Invitation',
  },
  'story-1': {
    title: 'With Love',
    paragraph: 'Together with our families, we joyfully invite you to celebrate the beginning of our new life together. Your presence would mean the world to us as we begin this beautiful journey.',
  },
  'countdown-1': {
    targetDateTime: '2026-09-12T16:00:00',
    label: 'Counting Down',
  },
  'details-1': {
    items: [
      { title: 'Ceremony', time: '16:00', description: 'The wedding ceremony begins at the garden pavilion.' },
      { title: 'Cocktail Hour', time: '17:30', description: 'Drinks and light bites on the terrace.' },
      { title: 'Dinner & Party', time: '19:00', description: 'Dinner followed by dancing under the stars.' },
    ],
    venue: 'Quinta da Serra',
    address: 'Sintra, Portugal',
  },
  'gallery-1': {
    images: [
      'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800',
      'https://images.unsplash.com/photo-1519741497674-611481863552?w=400',
      'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=400',
      'https://images.unsplash.com/photo-1606800052052-a08af7148866?w=400',
    ],
  },
  'rsvp-1': {
    title: 'RSVP',
    description: "We'd love to know if you can make it",
  },
  'venue-1': {
    venueName: 'Quinta da Serra',
    address: 'Rua da Serra 42, Sintra, Portugal',
    note: 'Complimentary parking available on site.',
  },
  'faq-1': {
    items: [
      { q: 'What is the dress code?', a: 'Semi-formal or cocktail attire. Think elegant but comfortable.' },
      { q: 'Can I bring a plus one?', a: 'Please refer to your invitation for details about additional guests.' },
      { q: 'Is there parking?', a: 'Yes, complimentary parking is available at the venue.' },
      { q: 'Will there be vegetarian options?', a: 'Absolutely! Please mention dietary needs in the RSVP form.' },
    ],
  },
  'footer-1': {
    closingMessage: "We can't wait to celebrate with you",
    names: 'Sofia & Miguel',
    contactText: 'Made with love',
  },
};

export default function TemplatePreview() {
  const { templateId } = useParams();
  const config = TEMPLATES[templateId];

  if (!config) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-light mb-2">Template not found</h1>
          <p className="text-gray-500">Available: {Object.keys(TEMPLATES).join(', ')}</p>
        </div>
      </div>
    );
  }

  return (
    <TemplateRenderer
      templateConfig={config}
      invitationData={SAMPLE_DATA}
      slug="preview"
    />
  );
}
